import { render, staticRenderFns } from "./FakeBotAssetSection.vue?vue&type=template&id=0dacdb03"
import script from "./FakeBotAssetSection.vue?vue&type=script&lang=js"
export * from "./FakeBotAssetSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports